import ResponseTicker from "../../ResponseTicker";
import type { Question, Response } from "../../../lib/types";

/** Stimmen: the poster wall of every visible answer (count-adaptive, newest spotlight). */
export function OpenVoices({
  responses,
  question,
  registerCardRef,
}: {
  responses: Response[];
  question: Question;
  registerCardRef?: (id: string, el: HTMLElement | null) => void;
}) {
  return <ResponseTicker responses={responses} question={question} registerCardRef={registerCardRef} />;
}
